import type { ReactElement } from 'react';

import { Loader, LoaderSizes } from '../../components/Loader';

/**
 * Экран ожидания первичной инициализации Keycloak (check-sso).
 *
 * @returns {ReactElement}
 */
export function AuthPending(): ReactElement {
  return (
    <main className='app-shell'>
      <Loader size={LoaderSizes.l} />
    </main>
  );
}
